import { defineAction } from '~/prix'
import { z } from 'zod'
import emergencyDispatchUpdateAction from './emergencyDispatchUpdate.action.json' with { type: 'json' }
import { emergencyDispatchUpdateInputObject } from '../emergencyDispatchObject'

const emergencyDispatchUpdateDefinition = defineAction({
  ...emergencyDispatchUpdateAction,

  input: emergencyDispatchUpdateInputObject,
  output: z.object({}),
})

export default emergencyDispatchUpdateDefinition
